export type RuntimeConfig = {
  appEnv: string;
  sentryClientDsn: string | null;
  recaptchaSiteKeyV3: string;
};

const getMetaContent = (name: string): string | null => {
  const meta = document.head.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  const content = meta?.content.trim();

  return content ? content : null;
};

const getRequiredMetaContent = (name: string): string => {
  const content = getMetaContent(name);

  if (!content) {
    throw new Error(`Missing required meta tag: ${name}`);
  }

  return content;
};

// Browser runtime config is rendered by Laravel so the same built bundle can run in many environments.
export const runtimeConfig: RuntimeConfig = {
  appEnv: getMetaContent('app-env') || 'production',
  sentryClientDsn: getMetaContent('sentry-client-dsn'),
  recaptchaSiteKeyV3: getRequiredMetaContent('recaptcha-site-key-v3'),
};
